const sectionLinks = [
  { href: '#hot', label: '热播剧' },
  { href: '#tv', label: '电视剧' },
  { href: '#movie', label: '电影' },
  { href: '#collection', label: '全集' },
  { href: '#source', label: '片源与清晰度' },
  { href: '#rank', label: '热度榜单' },
  { href: '#genre', label: '类型探索' },
  { href: '#faq', label: '常见问题' },
];

const topics = ['电视剧', '电影', '热播剧', '全集', '资源', '片源'];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-700 text-primary-50">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-50 text-primary-700">
                <i className="ri-cup-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold">茶杯狐影视</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-primary-100">
              围绕「内容类型与剧集资源」组织的信息导航页面，聚合电视剧、电影、热播剧与全集条目，并提供资源与片源的一般性说明。页面内容仅作信息浏览与分类参考。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {topics.map((topic) => (
                <span
                  key={topic}
                  className="px-3 py-1.5 text-xs rounded-full bg-primary-600 text-primary-50"
                >
                  {topic}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-heading text-sm font-bold tracking-wide text-primary-50">页面分区</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {sectionLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="inline-flex items-center gap-1.5 text-sm text-primary-100 cursor-pointer transition-colors hover:text-primary-50"
                  >
                    <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                    <span className="whitespace-nowrap">{link.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-sm font-bold tracking-wide text-primary-50">关于本站</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-primary-100">
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5" aria-hidden="true"></i>
                <span>条目信息以能确认的范围呈现，不完整处保留一般性描述。</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5" aria-hidden="true"></i>
                <span>本页不收集账号信息，筛选与搜索仅作用于本页内容。</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-refresh-line mt-0.5" aria-hidden="true"></i>
                <span>更新状态与热度排名会随内容进度变化。</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-600">
        <div className="px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-primary-100">© 2026 茶杯狐影视 · 内容导航页面</p>
          <p className="text-xs text-primary-100">电视剧 · 电影 · 热播剧 · 全集 · 资源 · 片源</p>
        </div>
      </div>
    </footer>
  );
}